// extracted by mini-css-extract-plugin
export default {"imgContainer":"ImgOnclickShowsDetail_imgContainer__kgvHe","detailsIconDiv":"ImgOnclickShowsDetail_detailsIconDiv__STD7u"};